import React, { Component, useEffect, useState } from 'react';
import * as d3 from "d3";
import havana from '../../../../../data/havana';

function Table (props) {

    const emptySpace = props.emptySpace,
        topLoci = props.topLoci,
        chr = props.chr,
        pos = props.pos,
        refV = props.refV,
        altV = props.altV,
        settings = props.settings,
        setLocus = props.setLocus,
        setSlot = props.setSlot,
        format = props.format,
        extra = props.extra,
        getExtra = props.getExtra;

    const [confirmedLocus, setConfirmedLocus] = useState(emptySpace);
    const [activeBB, setActiveBB] = useState(topLoci[0]);
    const [fullView, setFullView] = useState(false);
    const [filterView, setFilterView] = useState(false);
    const [activeFilter, setActiveFilter] = useState(undefined);
    const [orderParameter, setOrderParameter] = useState('pval')
    const [orderDirection, setOrderDirection] = useState(-1)

    const size = {
        margin:{ 
            top: 10,
            left: 200,
            gutter: 6,
            bottom: 11,
        },
        height: 30,
        tab:{
            s: 30,
            m: 50,
            l: 70,
            xl: 110,
        }
    };

    const width_3 = 3*size.tab.s+3*size.tab.l+3*size.tab.m,
        width_2 = 3*size.tab.s+3*size.tab.l+2*size.tab.m,
        width_1 = 3*size.tab.s+3*size.tab.l+1*size.tab.m

    function getBottomView (myLocus) {
        const chromosome = myLocus[chr],
            position = myLocus[pos]

        const newSlot = {
            chr: chromosome,
            low: position-50000,
            high: position+50000,
        }

        const newLocus = {
            chr: chromosome,
            low: position-20000,
            high: position+20000,
            pos: position,
        }

        setSlot(newSlot);
        setLocus(newLocus);
    }

    function getRect (datum, top) {
            const width = Math.log10(datum)/Math.log10(top)*(size.tab.l-10)
            return width
    }

    function drawFilters (data) {
        const filters = d3.groups(data.values, d=>d[chr]).sort((a,b)=>d3.ascending(a[0],b[0]));
        d3.select('#filters00').selectAll('button').data(filters).join(
            function(enter){
                enter.append('button').html(d=>d[0])
                    .classed('buttonPrimary', d => activeFilter === d[0])
                    .on('click', (e, d)=>setActiveFilter(d[0]))},
            function(update){update.html(d=>d[0]).classed('buttonPrimary', d => activeFilter === d[0])}
        )
    }

    function updateOrder (parameter) {
        const title = d3.select('#title00_'+parameter),
            text = title.html();

        if (parameter === orderParameter) {
            text.includes('↓') ? title.html(text.replace('↓','↑')) : title.html(text.replace('↑', '↓'))
            setOrderDirection(orderDirection*(-1));
        } else {
            const oldTitle = d3.select('#title00_'+orderParameter);
            oldTitle.html(oldTitle.html().replace(' ↓','').replace(' ↑',''));
            title.html(text+' ↓');
            setOrderDirection(-1);
            setOrderParameter(parameter);
        }
    }

    function drawResults (data, filter) {
        d3.select('#biobanks00').selectAll('button').classed('buttonPrimary',  d => data.biobank === d.biobank)

        var results
        if (filter === undefined) results = data.values
        else results = data.values.filter(el => el[chr] === filter)

        results.forEach((result, i) => {
            var genes = []
            havana.forEach(gene => {
                gene.chromosome===result[chr] && gene.start<=result[pos] && gene.stop>=result[pos] && genes.push(gene)
            })
            results[i] = {...result, genes: genes}
        })

        function compare (a, b) {
            var parameter;
            if (orderParameter === 'pval') parameter = data.biobank
            else if (orderParameter === 'beta') parameter = data.beta
            else if (orderParameter === 'pip') parameter = data.pip
            else if (orderParameter === 'af') parameter = data.af
            else if (orderParameter === 'pos') parameter = pos
            else if (orderParameter === 'chr') parameter = chr
            else if (orderParameter === 'ref') parameter = refV
            else if (orderParameter === 'alt') parameter = altV
            else if (orderParameter === 'gene') parameter = 'gene'

            if (parameter === 'gene') {
                const geneA = format('gn', a.genes.map(el => el.gene_name)),
                    geneB = format('gn', b.genes.map(el => el.gene_name));
                
                if (geneA === '-') return 1
                else if (geneB === '-') return -1
                else if (geneA < geneB) return 1*orderDirection;
                else if (geneA > geneB) return -1*orderDirection;
                else return 0;
            } else {
                if (a[parameter] < b[parameter]) return 1*orderDirection;
                else if (a[parameter] > b[parameter]) return -1*orderDirection;
                else return 0;
            }
        }

        results.sort(compare)

        const smallViewSize = 322
        const fullViewSize = size.margin.top+size.height*results.length+size.margin.bottom

        d3.select('#b_tableSize')
            .html(fullView ? 'Compress table' : 'Expand table')
            .style('display', fullViewSize < smallViewSize ? 'none' : undefined)
            .on('click', ()=>setFullView(!fullView));

        d3.select('svg').attr('height', fullView ? fullViewSize : smallViewSize)
        
        d3.select('#results00').selectAll('.unit').data(results).join(
            function(enter){
                const top = d3.min(data.values, d => d[data.biobank])
                const resultItem = enter.append('g')
                    .attr('class', 'unit')
                    .style('cursor', 'pointer')
                    .on('mouseenter', function(e){d3.select(this).select('.background').transition().attr('fill', settings.blue1)})
                    .on('mouseleave', function(e){d3.select(this).select('.background').transition().attr('fill', 'transparent')})
                    .on('click', (e,d) => {
                        getBottomView(d);
                        setFullView(false);
                        setConfirmedLocus(d[chr]+':'+d[pos]+':'+d[refV]+':'+d[altV]);
                    })
            
                resultItem.append('rect').attr('class', 'background').attr('x', 0).attr('y', (d,i) => size.margin.top+size.height*i+10).attr('width',  3*size.tab.s+3*size.tab.l+3*size.tab.m+size.tab.xl).attr('height', size.height).attr('fill', 'transparent')
                resultItem.append('text').attr('class', 'smallText chr').attr('x', 2).attr('y', (d,i) => size.margin.top+size.height*(i+1)).html(d => d[chr])
                resultItem.append('text').attr('class', 'smallText pos').attr('x', size.tab.s).attr('y', (d,i) => size.margin.top+size.height*(i+1)).html(d => d[pos])
                resultItem.append('text').attr('class', 'smallText ref').attr('x', size.tab.s+size.tab.l).attr('y', (d,i) => size.margin.top+size.height*(i+1)).html(d => d[refV])
                resultItem.append('text').attr('class', 'smallText alt').attr('x', 2*size.tab.s+size.tab.l).attr('y', (d,i) => size.margin.top+size.height*(i+1)).html(d => d[altV])
                resultItem.append('text').attr('class', 'smallText pvl').attr('x', 3*size.tab.s+size.tab.l).attr('y', (d,i) => size.margin.top+size.height*(i+1)).html(d => format('pv', d[data.biobank]))
                resultItem.append('rect').attr('class', 'rec').attr('x', 3*size.tab.s+2*size.tab.l).attr('y', (d,i) => size.margin.top+size.height*(i+0.6)).attr('height', size.height/2).attr('width', d => getRect(d[data.biobank], top)).style('fill', 'white')
                resultItem.append('text').attr('class', 'smallText bet').attr('x', 3*size.tab.s+3*size.tab.l).attr('y', (d,i) => size.margin.top+size.height*(i+1)).html(d => format('bt', d[data.beta]))
                extra.pip && resultItem.append('text').attr('class', 'smallText pip').attr('x', width_1).attr('y', (d,i) => size.margin.top+size.height*(i+1)).html(d => format('pp', d[data.pip]))
                extra.af && resultItem.append('text').attr('class', 'smallText af').attr('x', getExtra(width_2, width_1, undefined)).attr('y', (d,i) => size.margin.top+size.height*(i+1)).html(d => format('af', d[data.af]))
                resultItem.append('text').attr('class', 'smallText gen').attr('x', getExtra(width_3, width_2, width_1)).attr('y', (d,i) => size.margin.top+size.height*(i+1)).html(d => format('gn', d.genes.map(el => el.gene_name)))
                resultItem.append('line').attr('class', 'normalLine').attr('x1',0).attr('x2', 3*size.tab.s+3*size.tab.l+3*size.tab.m+size.tab.xl).attr('y1', (d,i) => size.margin.top+size.height*(i+1)+10).attr('y2', (d,i) => size.margin.top+size.height*(i+1)+10)
                resultItem.style('opacity', 0).transition().style('opacity', 1)
                return resultItem
            },
            function(update){
                const top = d3.min(data.values, d => d[data.biobank])
                update.select('.chr').html(d => d[chr])
                update.select('.pos').html(d => d[pos])
                update.select('.ref').html(d => d[refV])
                update.select('.alt').html(d => d[altV])
                update.select('.pvl').html(d => format('pv', d[data.biobank]))
                update.select('.bet').html(d => format('bt', d[data.beta]))
                extra.pip && update.select('.pip').html(d => format('pp', d[data.pip]))
                extra.af && update.select('.af').html(d => format('af', d[data.af]))
                update.select('.gen').html(d => format('gn', d.genes.map(el => el.gene_name)))
                update.select('.rec').transition().duration(500).attr('width', d => getRect(d[data.biobank], top))
            },
            function(exit){
                exit.transition().style('opacity', 0)
                    .transition().remove()
            })
        
    }

    useEffect (()=>{

        d3.select('#b_tableFilter')
            .html(filterView ? 'Remove filter' : 'Filter table')
            .classed('buttonPrimary', filterView)
            .on('click', ()=>{
                setActiveFilter(undefined)
                setFilterView(!filterView)
            })
    
        d3.select('#biobanks00').selectAll('button').data(topLoci).enter().append('button')
            .style('display', 'block')
            .classed('buttonPrimary', (d,i) => i === 0)
            .html(d => format('bb', d.biobank))
            .on('click', (e,d) => setActiveBB(d))
        
        drawResults(activeBB, activeFilter);
        drawFilters(activeBB);
    })

    return (
        <div id="table" className="section">
            <div className="section_header">
                <h1>Top association table</h1>
                <div className="section_header_buttons">
                    <button id='b_tableFilter'></button>
                    <button id='b_tableSize'></button>
                </div>
            </div>
            {filterView && (<div id='filters00'/>)}
            <div id='container00' >
                <div className="section_content">
                    <div style={{display: 'flex'}}>
                        <div style={{marginRight:size.margin.gutter, width: size.margin.left}}>
                            <div id='title00' className='smallText' style={{padding: (size.margin.top-9)+'px 0 6px 0'}}>Biobanks</div>
                            <div id='biobanks00' style={{width: 200}}></div>
                        </div>
                        <svg id='chart00' 
                            width={extra.af ? 3*size.tab.s+3*size.tab.l+3*size.tab.m+size.tab.xl : 3*size.tab.s+3*size.tab.l+2*size.tab.m+size.tab.xl} 
                            height={size.margin.top+size.height*20+size.margin.bottom}
                            >
                            <g id='table00'>
                                <g id='titles00' className='smallText'>
                                    <line className='thickLine' x1={0} x2={3*size.tab.s+3*size.tab.l+3*size.tab.m+size.tab.xl} y1={size.margin.top+10} y2={size.margin.top+10}></line>
                                    <text id='title00_chr' className='smallText linkText' y={size.margin.top} x={2} onClick={() =>updateOrder('chr')}>Chr</text>
                                    <text id='title00_pos' className='smallText linkText' y={size.margin.top} x={size.tab.s} onClick={() =>updateOrder('pos')}>Pos</text>
                                    <text id='title00_ref' className='smallText linkText' y={size.margin.top} x={size.tab.s+size.tab.l} onClick={() =>updateOrder('ref')}>Ref</text>
                                    <text id='title00_alt' className='smallText linkText' y={size.margin.top} x={2*size.tab.s+size.tab.l} onClick={() =>updateOrder('alt')}>Alt</text>
                                    <text id='title00_pval' className='smallText linkText' y={size.margin.top} x={3*size.tab.s+size.tab.l} onClick={() =>updateOrder('pval')}>P-value ↓</text>
                                    <text id='title00_beta' className='smallText linkText' y={size.margin.top} x={3*size.tab.s+3*size.tab.l} onClick={() =>updateOrder('beta')}>Beta</text>
                                    {extra.pip && (<text id='title00_pip' className='smallText linkText' y={size.margin.top} x={width_1} onClick={() =>updateOrder('pip')}>PIP</text>)}
                                    {extra.af && (<text id='title00_af' className='smallText linkText' y={size.margin.top} x={getExtra(width_2, width_1, undefined)} onClick={() =>updateOrder('af')}>AF</text>)}
                                    <text id='title00_gene' className='smallText linkText' y={size.margin.top} x={getExtra(width_3, width_2, width_1)} onClick={() =>updateOrder('gene')}>Genes</text>
                                </g>
                                <g id='results00'></g>
                            </g>
                        </svg>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <div
                            id='confirmed00'
                            className={confirmedLocus === emptySpace ? 'box' : 'box boxActive'}
                            style={{margin: '30px 0 0 0', width: 125}}
                            >
                            <button className="tabInput">{confirmedLocus}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Table;